import React, { useMemo } from 'react';
import T from 'prop-types';

import ChartLayout from '../ChartLayout';
import { SmartChart } from '../../../../../../components/Chart';

import { baseMetrics } from '../../../../config/constants';
import { periodChangeTypeCaptures } from '../../../../config/period-change-type';
import { baseDriversConfig } from '../../../../config/charts';

const emptyArray = [];

// Note: Used in the Comapny page and QV
const BaseChart = ({
  data,
  title,
  metric,
  overPeriod,
  chartStyleOverride,
}) => {
  const seriesByMetric = data.metrics?.[`${metric}_change`] || emptyArray;
  const hasPartialPeriod = !!data.partial_days;

  const seriesData = useMemo(() => {
    const getPartialColor = color => `url(#custom-pattern-${color}-column)`;

    return {
      [metric]: seriesByMetric.map(([timestamp, value], index) => {
        const isLastPoint = index === seriesByMetric.length - 1;
        return {
          x: timestamp,
          y: value,
          ...((isLastPoint && hasPartialPeriod) ? {
            isPartial: true,
            color: value >= 0 ? getPartialColor('#3E8EDE') : getPartialColor('#E33963'),
          } : {}),
        };
      }),
    };
  }, [metric, seriesByMetric, hasPartialPeriod]);

  const metaSeriesData = useMemo(() => ({
    [metric]: {
      color: '#3E8EDE',
      negativeColor: '#E33963',
      type: 'column',
      visible: true,
      name: metric,
    },
  }), [metric]);

  const chartConfig = useMemo(() => baseDriversConfig(seriesByMetric, {
    chartData: data,
    overPeriod,
    chartStyleOverride,
  }), [seriesByMetric, overPeriod, data, chartStyleOverride]);

  return (
    <ChartLayout
      header={<h5 className="h5">{title}</h5>}
      subheader={(
        <>
          <span className="eyebrow">{baseMetrics[metric]}</span>
          <span className="period-capture">{periodChangeTypeCaptures[overPeriod]}</span>
        </>
      )}
    >
      <SmartChart
        chartId="drivers-chart"
        series={seriesData}
        metaSeriesData={metaSeriesData}
        config={chartConfig}
        allowPartialPeriods={hasPartialPeriod}
      />
    </ChartLayout>
  );
};

BaseChart.propTypes = {
  data: T.object.isRequired,
  title: T.string.isRequired,
  metric: T.string.isRequired,
  overPeriod: T.string.isRequired,
  chartStyleOverride: T.object,
};

export default BaseChart;
